export class ManagerCalculationRow {
  yearLabel: string;
  taxYear: number;

  prior0: number;
  prior1: number;
  prior2: number;
  average: number;
  base: number;
  current: number;
  increase: number;
  credit: number;
  laCredit: number;

  // Federal R&D expenditures (cross reference only; not part of the credit calculation).
  prior0Fed: number;
  prior1Fed: number;
  prior2Fed: number;
  currentFed: number;

  constructor(row?: any) {
    if (row) {
      Object.assign(this, row);
    }
  }

  get creditPercent(): number {
    return this.credit == null ? null : parseFloat((this.credit * 100).toFixed(6));
  }
  set creditPercent(value: number) {
    this.credit =
      value == null || (value as any) === ''
        ? null
        : parseFloat((Number(value) / 100).toFixed(8));
  }
}

export class ManagerTaxCreditCalculation {
  copiedFromApplicant: boolean;
  rows: ManagerCalculationRow[];
  notes: string;

  constructor(managerCalculation?: any) {
    if (managerCalculation) {
      Object.assign(this, managerCalculation);
      this.rows = (managerCalculation.rows || []).map(r => new ManagerCalculationRow(r));
    } else {
      this.copiedFromApplicant = false;
      this.rows = [];
    }
  }
}
